<template>
  <q-page
    class="column no-wrap"
    style="max-height: calc(100vh - 150px)"
  >
    <q-toolbar
      v-if="grantedRoutes.length > 1"
      class="col-auto bg-primary text-white"
    >
      <q-tabs>
        <q-route-tab
          v-for="grantedRoute in grantedRoutes"
          :key="grantedRoute.name"
          :to="{ name: grantedRoute.name }"
          :label="`Contrats ${grantedRoute.meta.label}`"
        />
      </q-tabs>
    </q-toolbar>
    <router-view class="col q-py-xs" />
  </q-page>
</template>

<script>
import routeContracts from '@/router/platform/routeContracts'
import { isGrantedRoute } from '@/utils/security'

export default {
  name: 'Contracts',
  computed: {
    grantedRoutes () {
      return routeContracts.filter(isGrantedRoute)
    }
  }
}
</script>

<style scoped>

</style>
